






<nav mat-tab-nav-bar [backgroundColor]="background">
  <a mat-tab-link *ngFor="let link of links"
     [routerLink]="link.link"
     [queryParams]="{network: 'facebook',type:'performance'}"
     (click)="activeLink = link.link"
     [active]="activeLink == link.link"> {{link.name}} </a>
</nav>


<router-outlet name="report"> </router-outlet>
